import React from 'react';
import styled, { css } from 'styled-components';
import { minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, Video } from './ui';

const StyledExternalVideo = styled.section`
  ${({ isBlogDetail, isCaseStudyDetail, isSalesforceExplainerDetail }) => {
    if (!isBlogDetail && !isCaseStudyDetail && !isSalesforceExplainerDetail) {
      return css`
        ${sectionMargins()};
      `;
    } else {
      return css`
        ${sectionMargins('20px', '40px')};
      `;
    }
  }}
`;

const StyledContainer = styled(Container)`
  ${({ isBlogDetail }) => {
    if (isBlogDetail) {
      return css`
        padding-left: 0;
        padding-right: 0;
      `;
    }
  }};
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const ExternalVideo = ({
  heading,
  video,
  isBlogDetail,
  isCaseStudyDetail,
  isSalesforceExplainerDetail,
}) => (
  <StyledExternalVideo
    isBlogDetail={isBlogDetail}
    isCaseStudyDetail={isCaseStudyDetail}
    isSalesforceExplainerDetail={isSalesforceExplainerDetail}
  >
    <StyledContainer
      narrower={isBlogDetail || isSalesforceExplainerDetail}
      narrow={true}
      isBlogDetail={isBlogDetail}
    >
      {heading && <StyledHeading>{heading}</StyledHeading>}
      <Video data={video} />
    </StyledContainer>
  </StyledExternalVideo>
);

export default ExternalVideo;
